import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';

@Component({
  selector: 'app-fields-interventions-speed-per-operation-trailer-report',
  templateUrl: './fields-interventions-speed-per-operation-trailer-report.component.html',
  styleUrls: ['./fields-interventions-speed-per-operation-trailer-report.component.scss']
})
export class FieldsInterventionsSpeedPerOperationTrailerReportComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  toolbarDs: DataSource;

  @Input()
  dataSource: PivotGridDataSource;

  @Input()
  currentReportType: any;

  @Input()
  reportCurrentViewModes: any;

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  @Input()
  width: number;

  @Input()
  height: number;

  constructor() {
  }

  ngOnInit(): void {

    // Set fields
    this.dataSource.fields([{
      caption: 'BU',
      width: 120,
      dataField: 'business_unit_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Domaine',
      width: 120,
      dataField: 'domain_name',
      allowFiltering: true,
      area: 'filter',
    }, {
      caption: 'Operation',
      dataField: 'trailer_operation_type',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Tracteur',
      dataField: 'tractor_name',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Outil',
      dataField: 'trailer_name',
      width: 150,
      allowFiltering: true,
      area: 'row'
    }, {
      caption: 'Année',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'year',
      area: 'column'
    }, {
      caption: 'Mois',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'month',
      area: 'column'
    }, {
      caption: 'Jour',
      dataField: 'start_time',
      dataType: 'date',
      groupInterval: 'day',
      area: 'column'
    }, {
      caption: 'Vitesse moyenne au travail km/h',
      dataField: 'working_in_field_speed_avg',
      dataType: 'number',
      summaryType: 'avg',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }, {
      caption: 'Vitesse maximale au travail km/h',
      dataField: 'working_in_field_speed_max',
      dataType: 'number',
      summaryType: 'max',
      format: {type: 'fixedPoint', precision: 2},
      area: 'data'
    }]);

    this.toolbarDs.store().push([{
      type: 'update',
      data: {
        options: {
          onClick: () => {
            this.pivotGrid.instance.getFieldChooserPopup().show();
          }
        }
      },
      key: 'filter',
    },
      {
        type: 'update',
        data: {
          options: {
            onClick: () => {
              this.dataSource.reload();
            }
          }
        },
        key: 'refresh',
      }]);
  }

  ngAfterViewInit(): void {
    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'singleAxis',
      inverted: true,
      alternateDataFields: false,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        chartOptions.valueAxis[0].label = {
          customizeText: (args) => {
            return args.value.toFixed(2) + ' km/h';
          }
        };
        return chartOptions; // This line is optional
      },
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.dataSource);
  }

  ngOnDestroy(): void {
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + args.originalValue.toFixed(2) + ' km/h'
    };
  }
}

